import _ from 'lodash';
import type { TableColumns } from '@/vantage/types/TableConfig.types';

export const findConditionIdColumnNames = (columns: TableColumns): string[] =>
  _.chain(columns)
    .values()
    .flatMap((group) => Object.entries(group))
    .filter(([, { meta }]) => meta?.type?.toString().toLowerCase() === 'condition_id')
    .map(([columnName]) => columnName)
    .value();

export const findConditions = (columns: TableColumns, conditionIdColumnNames: string[]): string[] =>
  _.chain(columns)
    .values()
    .flatMap((group) => Object.entries(group))
    .filter(
      ([, { meta }]) =>
        meta?.type?.toString().toLowerCase() === 'reference' && conditionIdColumnNames.includes(meta?.referenced),
    )
    .map(([columnName]) => columnName)
    .value();
